import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './BottomNav.css';

interface NavItem {
  path: string;
  label: string;
  icon: string;
}

export const BottomNav: React.FC = () => {
  const location = useLocation();
  const { user } = useAuth();

  const baseNavItems: NavItem[] = [
    { path: '/', label: 'Home', icon: 'fas fa-home' },
    { path: '/tracking', label: 'Tracking', icon: 'fas fa-map-marker-alt' },
    { path: '/profile', label: 'Profile', icon: 'fas fa-user' },
  ];

  // Add technician link if user is a technician
  const isTechnician = user?.user_metadata?.role === 'technician';
  const navItems = isTechnician 
    ? [...baseNavItems, { path: '/technician', label: 'Tech', icon: 'fas fa-tools' }]
    : baseNavItems;

  return (
    <nav className="bottom-nav">
      {navItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
        >
          <i className={item.icon}></i>
          <span className="nav-label">{item.label}</span>
        </Link>
      ))}
    </nav>
  );
};
